import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LoaderService } from "../../services/loader/loader.service";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.css"],
})
export class LoadingComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  unsubscribe: Subscription[] = [];

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    const sub = this.loaderService.loading.subscribe((data: boolean) => {
      this.loading = data;
    });
    this.unsubscribe.push(sub);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((subs) => {
      subs.unsubscribe();
    });
  }
}
